import { render } from "./TagList.vue?vue&type=template&id=0aa3b00f&scoped=true"
import script from "./TagList.vue?vue&type=script&lang=js"
export * from "./TagList.vue?vue&type=script&lang=js"

import "./TagList.vue?vue&type=style&index=0&id=0aa3b00f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexty-frontend/nexty-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa3b00f"]])

export default __exports__